/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DecimalPlacesTypeEnum {
    ZERO = 'ZERO',
    ONE = 'ONE',
    TWO = 'TWO',
    THREE = 'THREE',
    FOUR = 'FOUR',
    FIVE = 'FIVE',
    SIX = 'SIX',
}
